uniform float uTime;
uniform float uPixelRatio;
uniform float uSize;

attribute float aScale;
attribute float aRandomness;

varying float vAlpha;

void main()
{
    vec4 modelPosition = modelMatrix * vec4(position, 1.0);

    // Subtle floating movement
    modelPosition.y += sin(uTime * 0.3 + aRandomness * 10.0) * 0.3;
    modelPosition.x += cos(uTime * 0.2 + aRandomness * 8.0) * 0.2;

    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectionPosition = projectionMatrix * viewPosition;

    gl_Position = projectionPosition;

    // Smaller, more subtle particles
    gl_PointSize = uSize * aScale * uPixelRatio;
    gl_PointSize *= (1.0 / - viewPosition.z);

    // Fade based on distance
    vAlpha = smoothstep(15.0, 5.0, length(viewPosition.xyz)) * aScale;
}
